import type { ExtractedField } from '../../../lib/api/exploreDetails/dto';
import { type DateRangeOption, LOOKER_DATE_RANGES } from '../../HCPSiteWorkspaceView/helpers/constants';

export const DATA_DICTIONARY_COLUMNS = [
  { id: 'fieldLabel', header: 'Field Label', accessorKey: 'fieldLabel', size: 200, meta: { wrapCells: true } },
  { id: 'category', header: 'Category', accessorKey: 'category', size: 100, meta: { wrapCells: true } },
  { id: 'type', header: 'Type', accessorKey: 'type', size: 100, meta: { wrapCells: true } },
  { id: 'source', header: 'Source', accessorKey: 'source', size: 100, meta: { wrapCells: true } },
  { id: 'definition', header: 'Definition', accessorKey: 'definition', size: 200, meta: { wrapCells: false } },
];

export const SEARCH_FIELDS: (keyof ExtractedField)[] = ['fieldLabel', 'category', 'type', 'source', 'definition'];

export const COLUMN_SPACING_OFFSET = 24;

export const BRAND_EXPLORERDATE_RANGE_OPTIONS: Array<{ value: DateRangeOption; label: string }> = [
  { value: LOOKER_DATE_RANGES.YESTERDAY, label: 'Yesterday' },
  { value: LOOKER_DATE_RANGES.LAST_7_DAYS, label: 'Last 7 Days' },
  { value: LOOKER_DATE_RANGES.LAST_2_WEEKS, label: 'Last 14 Days' },
  { value: LOOKER_DATE_RANGES.LAST_30_DAYS, label: 'Last 30 Days' },
  { value: LOOKER_DATE_RANGES.LAST_60_DAYS, label: 'Last 60 Days' },
  { value: LOOKER_DATE_RANGES.LAST_90_DAYS, label: 'Last 90 Days' },
  { value: LOOKER_DATE_RANGES.LAST_180_DAYS, label: 'Last 180 Days' },
  { value: LOOKER_DATE_RANGES.LAST_365_DAYS, label: 'Last 365 Days' },
  { value: 'custom', label: 'Custom' },
];

export const DATA_UPDATE_DELAY = 1_000;

export const SEGMENT_KEYS = ['bi_hcp365_npi_list_agg.listname', 'bi_hcp365_npi_list.listname'];

export const TIMEFRAME_FIELD = 'hcp365_core.day';
export const TIMEFRAME_DEFAULT_VALUE = BRAND_EXPLORERDATE_RANGE_OPTIONS[1].value;
